import { useRef } from "react";
import moment from "moment";
import { useTypedSelector } from "hooks";
import type { ResourceResponse } from "types";
import { toBooleanSwitch } from "util/casts";
import type { AbstractFileEntity, Files } from "features/merchantPayouts/types";
import { selectIsMerchantPayoutEntityLoading } from "features/merchantPayouts/selectors";
import useActions from "features/merchantPayouts/useActions";
import { useLabeledSwitch } from "ui/atoms/LabeledSwitch";
import { useModal } from "ui/atoms/Modal";

export default function usePayableControl(entity: Files) {
    const { open, onOpen, onClose } = useModal();
    const isRequestLoading = useTypedSelector(selectIsMerchantPayoutEntityLoading);
    const { putMerchantPayoutFiles } = useActions();
    const stubHandler = (_: boolean) => { };

    const actionControlsRef = useRef({
        resolve: stubHandler,
        reject: stubHandler
    });

    // const handleRequest = useSimpleRequest();

    // const { isLoading, handleProcess } = useProcess((isChecked = Boolean(entity.isPaid)) =>
    //     handleRequest(() =>
    //         paidMerchantPayoutFiles(
    //             entity.coreId,
    //            {[Filters.isPaid]:`${Number(isChecked)}`}
    //         ), { notifyOnSuccess: true }));

    const confirmationHandler = () => {
        onOpen();

        return new Promise<boolean>((resolve, reject) => {
            actionControlsRef.current = {
                resolve,
                reject
            };
        });
    };

    const getDisabled = () => {
      const { parentId, updatedAt, isPaid, fileKey } = entity;
      return (parentId === null) && Boolean(Number(isPaid))
        ? !moment(updatedAt).isSame(new Date(), "day")
        : Boolean(fileKey === null);
    };

    const labeledSwitchProps = useLabeledSwitch({
        i18n: ['Unpaid', 'Paid'],
        getDefaultChecked: () => Boolean(Number(entity.isPaid)),
        confirmationHandler
    });

    const onProceed = async () => {
        const [request] = putMerchantPayoutFiles({
            coreId: entity.coreId,
            MOR: entity.MOR,
            isPaid: toBooleanSwitch(labeledSwitchProps.getChecked())
        });

        const { success } = await request as ResourceResponse<AbstractFileEntity>;

        actionControlsRef.current.resolve(success);

        onClose();
        // handleProcess(labeledSwitchProps.getChecked())
        //     .then(({ success }) => actionControlsRef.current.resolve(success))
        //     .finally(onClose);
    };

    const onCancel = () => {
        actionControlsRef.current.reject(false);
        onClose();
    };

    return {
        ...labeledSwitchProps,
        getDisabled,
        open,
        isLoading: isRequestLoading,
        onProceed,
        onCancel
    };
};
